import {
    defaultServiceOrdersForFlag,
    SERVICE_ORDER_FLAGS,
} from '../../constants/defaultServiceOrder';
import { IFeatures } from '../../models/featureFlags';

export const Features: IFeatures = {
    /** Shows push notification */
    EnableNotification: {
        name: 'enableNotificationSettings',
        defaultValue: false,
    },

    /** Shows push notification preview tag */
    DisableNotificationPreview: {
        name: 'disableNotificationPreview',
        defaultValue: false,
    },

    /** Routes notification api to portal */
    EnableNotificationProxy: {
        name: 'apollo-enableNotificationProxy',
        defaultValue: false,
    },

    /** Enable Single Session Enforcement */
    EnablePortalShellSingleSession: {
        name: 'enable-portal-shell-single-session',
        defaultValue: true,
    },

    /** Enable Auth */
    EnablePortalShellSelfAuth: {
        name: 'enable-portal-shell-self-auth',
        defaultValue: true,
    },

    /** Enable Local storage overrides for env config fields */
    EnablePortalShellLocalStorageOverrides: {
        name: 'enable-portal-shell-localstorage-overrides',
        defaultValue: false,
    },

    /** Enable using self auth in people picker */
    EnablePortalShellSelfAuthPeoplePicker: {
        name: 'enable-portal-shell-self-auth-people-picker',
        defaultValue: false,
    },

    /** Enable Idle Timeout */
    EnablePortalShellIdleTimeout: {
        name: 'enable-portal-shell-idle-timeout',
        defaultValue: false,
    },

    /** Enable Global Focus */
    EnableGlobalFocus: {
        name: 'enable-global-focus',
        defaultValue: false,
    },

    /** Enable Keys language */
    EnableLocKeysLanguage: {
        name: 'enable-loc-keys-language',
        defaultValue: false,
    },

    /** Enable force parsing the URL for info */
    EnablePortalShellUrlParams: {
        name: 'enable-portal-shell-url-params',
        defaultValue: true,
    },

    /** Enable 48px app-bar */
    EnableAppBarThinner: {
        name: 'enable-appbar-thinner',
        defaultValue: true,
    },

    EnablePeoplePickerIdentityBaseUrlOverride: {
        name: 'apollo-enablePeoplePickerIdentityBaseUrlOverride',
        defaultValue: false,
    },

    EnableEcommerceInJapan: {
        name: 'enableEcommerceInJapan',
        defaultValue: false,
    },

    EnableLeftNavRedesign: {
        name: 'apollo-enableLeftNavRedesign',
        defaultValue: false,
    },

    EnableLeftNavServiceRevamp: {
        name: 'apollo-enableLeftNavServiceRevamp',
        defaultValue: false,
    },

    EnableLeftNavMenuExpansion: {
        name: 'apollo-enableLeftNavMenuExpansion',
        defaultValue: false,
    },

    EnableFirstPartyClientPrefetch: {
        name: 'apollo-enableFirstPartyClientPrefetch',
        defaultValue: false,
    },

    /** Service orders for left nav revamp -- the `?? {}` is because in e2e tests the import doesn't work apparently */
    ...Object.keys(SERVICE_ORDER_FLAGS ?? {}).reduce((acc, key) => (
        {
            ...acc,
            [key]: {
                name: SERVICE_ORDER_FLAGS[key],
                defaultValue: defaultServiceOrdersForFlag[SERVICE_ORDER_FLAGS[key]],
            },
        }
    ), {}),

    /** Enables the zh-TW language */
    EnableLanguageZhTw: {
        name: 'enable-language-zh-tw',
        defaultValue: false,
    },

    /** Enable debug logging to appInsights */
    EnableAppInsightsDebugLogging: {
        name: 'apollo-enable-app-insights-debug-logging',
        defaultValue: false,
    },

    /** Enable upgrade dialog in profile menu */
    EnableUpgradeDialogOffersRevamp: {
        name: 'EnableUpgradeDialogOffersRevamp',
        defaultValue: false,
    },

    /** Enables persisting a theme per-user-per-partition */
    EnableUserTheme: {
        name: 'enableUserTheme',
        defaultValue: false,
    },

    /** Right now, enables using the window custom events */
    EnablePortalShellV3: {
        name: 'apollo-enablePortalShellV3',
        defaultValue: false,
    },

    PersonaRefetchThrottleMs: {
        name: 'apollo-personaRefetchThrottleMs',
        defaultValue: 1000 * 60 * 5,
    },

    AccountAndTenantsRefetchThrottleMs: {
        name: 'apollo-accountAndTenantsRefetchThrottleMs',
        defaultValue: 1000 * 60 * 5,
    },
};

export const DefaultValuesMap = Object.values(Features).reduce((accumulator, current) => {
    accumulator[current.name] = current.defaultValue;
    return accumulator;
}, {});
